/** The calendar invite card on an inbound meeting invitation. */
export const enCalendarInvite = {
	title: "Calendar Invite",
	accept: "Accept",
	decline: "Decline",
	tentative: "Tentative",
	addToCalendar: "Add to My Calendar",
	tentativeTooltip: "Respond as tentatively accepted",
	addToCalendarTooltip: "Download .ics file to add to your calendar",
	status: {
		pending: "Pending",
		accepted: "Accepted",
		declined: "Declined",
		tentative: "Tentative",
	},
};
